<template>
    <rkm-modal
        :loading="loading"
        :buttons="['cancel']"
        :title="`Atendimentos assinados (FAA: ${faa} - ${data})`"
        extra-large
        ref="Modal"
    >
        <rkm-table
            :items="atendimentos"
            :fields="fields"
            sort-by="dataHora"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    color="primary"
                    small
                    title="Imprimir"
                    @click="print(`${item.tipoIdentificador}${item.id}`)"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalOpcaoImpressao ref="ModalOpcaoImpressao" />
    </rkm-modal>
</template>

<script>
// Components
import ModalOpcaoImpressao from './components/opcao/Modal'

// Others
import { mapGetters, mapActions } from 'vuex'
import { repository, error, formats, file } from '@/mixins'

export default {
    components: { ModalOpcaoImpressao },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'tipo',
                    label: 'Tipo',
                    sortable: true,
                    class: 'col-min',
                },
                {
                    key: 'dataHora',
                    label: 'Data/hora',
                    sortable: true,
                    class: 'col-min',
                    formatter: value => this.formatDateTime(value),
                    filterByFormatted: true,
                },
                {
                    key: 'profissional',
                    label: 'Profissional',
                    sortable: true,
                },
                {
                    key: 'ocupacao',
                    label: 'CBO',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]
        },
    },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('prontoAtendimento.impressao')
        }
    },
    data: () => ({
        faa: '',
        data: '',
        atendimentoAssinado: {},
        receitasMedicasAssinadas: {},
        atendimentos: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(atendimentoId, faa, data) {

            this.faa = faa
            this.data = data
            this.atendimentos = []

            this.load(atendimentoId)

            this.$refs.Modal.show()
        },
        load(atendimentoId) {

            this.setLoading()

            this.repositories.impressao.getAtendimentosAssinados(atendimentoId)
                .then(({ data }) => this.atendimentos = data.map(atendimento => {

                    const identificador = `${atendimento.tipoIdentificador}${atendimento.id}`

                    this.atendimentoAssinado[identificador] = atendimento.faaAssinada

                    if (atendimento.receitasMedicasAssinadas.length > 0) {

                        this.receitasMedicasAssinadas[identificador] = atendimento.receitasMedicasAssinadas
                    }

                    delete atendimento.faaAssinada
                    delete atendimento.receitasMedicasAssinadas

                    return atendimento
                }))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        print(identificador) {

            if (identificador in this.receitasMedicasAssinadas) {

                this.$refs.ModalOpcaoImpressao.open({
                    atendimento: this.atendimentoAssinado[identificador],
                    receitasMedicasAssinadas: this.receitasMedicasAssinadas[identificador],
                })
            }
            else {

                this.openPdfBase64(this.atendimentoAssinado[identificador])
            }
        }
    },
    mixins: [repository, error, formats, file],
}
</script>